// import { Clear } from "@mui/icons-material";
// import { Autocomplete, TextField } from "@mui/material";
// import React, { useState } from "react";
// import { Controller } from "react-hook-form";

// function Percentage({ setValue, getValues, control }) {
// 	const [percentage, setPercentage] = useState({
// 		label: `${getValues('percentage')}%`,
// 		value: getValues('percentage')
// 	});

// 	const data = Array.from(Array(getValues("percentage")).keys()).map((i) => ({
// 		label: `${i + 1}%`,
// 		value: i + 1,
// 	}));

// 	const handlePercentage = (_, selected) => {
// 		if (!selected?.value) return;

// 		const totalAmount =
// 			getValues("totalAmount");

// 		if (Boolean(totalAmount)) {
// 			setValue(
// 				"payableAmount",
// 				Math.round(
// 					(selected.value / 100) *
// 					parseInt(totalAmount)
// 				).toString()
// 			);

// 			setValue(
// 				"percentage",
// 				selected.value
// 			);

// 			setPercentage(selected);
// 		}
// 	};

// 	const handleClear = () => {
// 		setValue("payableAmount", 0);
// 		setValue("percentage", 100);

// 		setPercentage({
// 			label: "100%",
// 			value: 100
// 		});
// 	};

// 	return (
// 		<Controller
// 			name="percentage"
// 			control={control}
// 			render={({ field }) => (
// 				<Autocomplete
// 					sx={{ width: "30%" }}
// 					disablePortal
// 					id="percentage-dropdown"
// 					options={data}
// 					clearIcon={<Clear fontSize="small" />}
// 					componentsProps={{ clearIndicator: { onClick: handleClear } }}
// 					getOptionLabel={(option) => option.label}
// 					renderInput={(params) => (
// 						<TextField
// 							{...params}
// 							{...field}
// 							InputLabelProps={{
// 								shrink: true,
// 							}}
// 							placeholder="%"
// 							label="Percentage*"
// 							inputProps={{
// 								...params.inputProps,
// 								readOnly: true,
// 								onKeyDown: (e) => e.preventDefault()
// 							}}
// 						/>
// 					)}
// 					value={percentage}
// 					onChange={handlePercentage}
// 				/>
// 			)}
// 		/>
// 	);
// }

// export default Percentage;

import Select from 'react-select';
import { Controller } from 'react-hook-form';

function Percentage({ control, setValue, getValues, width = "30%", maxPercentage = 100, error = false }) {
	const parsedMaxPercentage = Number(maxPercentage);
	const optionLimit = Math.floor(
		Math.max(0, Number.isFinite(parsedMaxPercentage) ? parsedMaxPercentage : 100)
	);
	const options = [
		{
			label: 'Select Percentage',
			value: ''
		},
		...Array.from(
		{ length: optionLimit },
		(_, i) => ({
			label: `${i + 1}%`,
			value: i + 1
		})
		)
	];

	const handlePercentageChange = (selected) => {
		const percentage = selected?.value;
		if (!percentage) {
			setValue('percentage', '');
			setValue('payableAmount', '');
			return;
		}

		const totalAmount = Number(getValues('totalAmount'));

		const payableAmount = Math.round(
			(percentage / 100) * totalAmount
		);

		setValue('percentage', percentage);
		setValue('payableAmount', payableAmount.toString());
	}

	return (
		<Controller
			name='percentage'
			control={control}
			render={({ field }) => (
				<Select
					options={options}
					placeholder={'Select Percentage'}
					isClearable
					menuPortalTarget={document.body}
					value={options.find(option => option.value === field.value) || null}
					onChange={(selected) => {
						field.onChange(selected?.value)
						handlePercentageChange(selected)
					}}
					styles={{
						container: (base) => ({
							...base,
							width
						}),
						menuPortal: (base) => ({
							...base,
							zIndex: 9999
						}),
						control: (base) => ({
							...base,
							minHeight: '56px',
							fontSize: '14px',
							borderColor: error ? '#d32f2f' : base.borderColor,
							'&:hover': {
								borderColor: error ? '#d32f2f' : base.borderColor
							}
						}),
						valueContainer: (base) => ({
							...base,
							minHeight: '54px'
						}),
						indicatorsContainer: (base) => ({
							...base,
							minHeight: '54px'
						}),
						menu: (base) => ({
							...base,
							fontSize: '14px'
						}),
						option: (base) => ({
							...base,
							fontSize: '14px'
						})
					}}
				/>
			)}
		/>
	)
}

export default Percentage;
